/** Compatibility / responsiveness colors + word bands — ported from DeckView.swift. */

/** Red at 0 → green at 100 (hue 0..120°), same curve as iOS. */
export function scoreColor(pct: number): string {
  const t = Math.max(0, Math.min(100, pct)) / 100;
  return `hsl(${Math.round(t * 120)}, 90%, 55%)`;
}

export function responsivenessBand(pct: number): string {
  if (pct >= 85) return "Always responds";
  if (pct >= 50) return "Sometimes responds";
  if (pct >= 15) return "Seldom responds";
  return "Never responds";
}

export function compatibilityBand(pct: number): string {
  if (pct >= 90) return "Excellent";
  if (pct >= 80) return "Very Strong";
  if (pct >= 70) return "Strong";
  if (pct >= 60) return "Moderate";
  return "Weak";
}

export const RESPONSIVENESS_BANDS: { label: string; range: string }[] = [
  { label: "Always responds", range: "85–100" },
  { label: "Sometimes responds", range: "50–84" },
  { label: "Seldom responds", range: "15–49" },
  { label: "Never responds", range: "0–14" },
];

export const COMPATIBILITY_BANDS: { label: string; range: string }[] = [
  { label: "Excellent", range: "90–100" },
  { label: "Very Strong", range: "80–89" },
  { label: "Strong", range: "70–79" },
  { label: "Moderate", range: "60–69" },
  { label: "Weak", range: "Below 60" },
];
